// extracted by mini-css-extract-plugin
module.exports = {"root":"PRE8p","star":"_3DsbL"};